import angular from "angular";
import angulartics from "angulartics/dist/angulartics.min.js";

export default angular.module("analytics", [
  "angulartics",
  require('angulartics-google-tag-manager')
]).name;



// WEBPACK FOOTER //
// ./src/ui/app/services/analytics.js